import {Component, Input, OnInit} from '@angular/core';
import {RealTimeContextService} from '../real-time-context.service';
import {Types} from '../../common/const';

@Component({
  selector: 'app-real-time-counter',
  templateUrl: './real-time-counter.component.html',
  styleUrls: ['./real-time-counter.component.scss']
})
export class RealTimeCounterComponent implements OnInit {

  @Input() key: string;
  @Input() type: any;
  @Input() title: string;
  @Input() icon: string;
  @Input() circle = false;
  @Input() value: number;
  @Input() downloadUrl: string;
  @Input() downloadTitle = '';
  @Input() classCheck: string;
  types = Types;

  constructor(
    private realTimeContextService: RealTimeContextService
  ) { }

  ngOnInit() {
  }

  toggleCategory(e) {
    this.type.showing = !this.type.showing;
    if (!e) {
      this.realTimeContextService.setCategories(this.realTimeContextService.getCategories());
    } else {
      this.realTimeContextService.setCategories(this.realTimeContextService.getCategories());
    }
  }

  cancelPropagation($event: Event) {
    $event.stopImmediatePropagation();
  }

}



// WEBPACK FOOTER //
// ./src/app/real-time/real-time-counter/real-time-counter.component.ts